import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import {
    IThinkAnalyticsSearchPARequest,
    IThinkAnalyticsSearchPAResponse,
} from '../../../entity/interface/iThinkAnalyticsSearch';
import { IThinkAnalyticsSearchRepository } from '../../repositories/interfaces/iThinkAnalyticsSearchRepository';

export interface IGetSearchPAUseCase {
    execute(payload: IThinkAnalyticsSearchPARequest, identityToken: string): Promise<IThinkAnalyticsSearchPAResponse>;
}

export class GetSearchPAUseCase implements IGetSearchPAUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get thinkAnalyticsSearchRepository(): IThinkAnalyticsSearchRepository {
        return container.resolve<IThinkAnalyticsSearchRepository>(DI.REPOSITORIES.IThinkAnalyticsSearchRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        payload: IThinkAnalyticsSearchPARequest,
        identityToken: string
    ): Promise<IThinkAnalyticsSearchPAResponse> {
        return this.thinkAnalyticsSearchRepository.searchPA(payload, identityToken);
    }
}
